import React, { useEffect } from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { getImage } from "../../contentful/data-provider";

export default function YellowSliderSection(props) {
	const { content } = props;

	useEffect(() => {
		const firstSlideTab = document.getElementById("tab-0");
		firstSlideTab.classList.add("active");
		firstSlideTab.setAttribute("aria-current", "true");

		const firstSlideItem = document.getElementById("item-0");
		firstSlideItem.classList.add("active");
	}, []);

	return (
		<>
			<section className='thrive slider-container'>
				<div className='container'>
                <div className="row section--header thrive--header">
                    <div className="col-lg-6">
                        <h2>{content.title}</h2>
                    </div>
                    <div className="col-lg-5 offset-lg-1">
                        {renderRichText(content.body)}
                    </div>
                </div>
					<div className='row'>
						<div className='col-lg-12 px-0'>
							<div id='carouselTab' className='carousel slide' data-bs-touch='true'>
								<div className='slider thrive--slider'>
									<div className='slider--header'>
										<ul className='carousel-indicators'>
											{content.elements.map((element, index) => {
												return (
													<li>
														<a
															id={`tab-${index}`}
															href={() => false}
															data-bs-target='#carouselTab'
															data-bs-slide-to={index}
															className={"index-elem"}
															aria-label={`Slide ${index}`}
														>
															{element.title}
														</a>
													</li>
												);
											})}
										</ul>
									</div>

									<div className='slider--content'>
										<div className='slick-list'>
											<ul className='carousel-inner'>
												{content.elements.map((element, index) => {
													return (
														<li id={`item-${index}`} key={index} className={`slider-col carousel-item`}>
															<div className='slider-item'>
																<div className='slider-item--text'>
																	<div className='decorate-container'>
																		<div className='decorate'>
																			<span className='decorate__item' />
																			<span className='decorate__item' />
																		</div>
																	</div>

																	<h3>{element.title}</h3>
																	{renderRichText(element.body)}
																	{element.ctaText && (
																		<a className='btn btn--black' href={element.ctaUrl}>
																			{element.ctaText}
																		</a>
																	)}
																</div>
																<div className='slider-item--image'>
																	<div className='decorate-container'>
																		<div className='decorate'>
																			<span className='decorate__item' />
																			<span className='decorate__item' />
																		</div>
																	</div>

																	<img src={getImage(element.image).url} alt={getImage(element.image).title} />
																</div>
															</div>
														</li>
													);
												})}
											</ul>
										</div>
									</div>

									<div className='slider--arrows'>
										<button className='arrow arrow-left' type='button' data-bs-target='#carouselTab' data-bs-slide='prev'>
											<span className='carousel-control-prev-icon' aria-hidden='true' />
											<span className='visually-hidden'>Previous</span>
										</button>

										<button className='arrow arrow-right' type='button' data-bs-target='#carouselTab' data-bs-slide='next'>
											<span className='carousel-control-next-icon' aria-hidden='true' />
											<span className='visually-hidden'>Next</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
